import React from 'react'
import i18next from 'i18next'
import { Button, Form, Row, Col } from 'react-bootstrap'
import isEmail from 'validator/lib/isEmail'
import { Trans } from 'react-i18next'

const { t } = i18next

class ReferenceForm extends React.Component {
  static defaultProps = {
    reference: {},
    onSave: () => {},
    closeForm: () => {},
  }

  state = {
    id: null,
    reference_name: '',
    reference_task: '',
    phone: '',
    email: '',
  }

  constructor(props) {
    super(props)
    if (props.reference.id) {
      let { id, reference_name, reference_task, phone, email } = props.reference
      this.state.id = id
      this.state.reference_name = reference_name || ''
      this.state.reference_task = reference_task || ''
      this.state.phone = phone || ''
      this.state.email = email || ''
    }
  }

  handleChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value })
  }

  isFormValid = () => {
    let { reference_name, email } = this.state
    return reference_name !== '' && (!email || isEmail(email))
  }

  handleConfirm = () => {
    this.props.onSave(this.state)
  }

  isEmailInvalid = () => {
    return this.state.email !== '' && !isEmail(this.state.email)
  }

  render() {
    let { reference_name, reference_task, phone, email } = this.state

    return (
      <>
        <div className="flex-fill position-relative overflow-auto">
          <div className="w-100 ps-1 pe-4 ">
            <Row>
              <Form.Group as={Col} className="mb-3 col-12">
                <Form.Label>
                  <Trans i18nKey="components.brands.reference_name">Nome</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="reference_name"
                  placeholder={t('components.brands.reference_name', 'Nome')}
                  value={reference_name}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} className="mb-3 col-12">
                <Form.Label>
                  <Trans i18nKey="components.brands.reference_task">Mansione</Trans>
                </Form.Label>
                <Form.Control
                  name="reference_task"
                  placeholder={t('components.brands.reference_task', 'Mansione')}
                  value={reference_task}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} className="mb-3 col-12">
                <Form.Label>
                  <Trans i18nKey="components.brands.phone">Telefono</Trans>
                </Form.Label>
                <Form.Control
                  name="phone"
                  placeholder={t('components.brands.phone', 'Telefono')}
                  value={phone}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} className="mb-3 col-12">
                <Form.Label>
                  <Trans i18nKey="components.brands.email">Email</Trans>
                </Form.Label>
                <Form.Control
                  name="email"
                  placeholder={t('components.brands.email', 'Email')}
                  value={email}
                  onChange={this.handleChange}
                  isInvalid={this.isEmailInvalid()}
                />
                <Form.Control.Feedback type="invalid">
                  <Trans i18nKey="components.brands.invalid_email">Indirizzo e-mail non valido</Trans>
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
          </div>
        </div>
        <div className="border-top pt-2">
          <Button className="float-end" variant="primary" disabled={!this.isFormValid()} onClick={this.handleConfirm}>
            <Trans i18nKey="buttons.confirm">Conferma</Trans>
          </Button>
          <Button className="float-end me-2" variant="secondary" onClick={this.props.closeForm}>
            <Trans i18nKey="buttons.cancel">Annulla</Trans>
          </Button>
        </div>
      </>
    )
  }
}

export default ReferenceForm
